var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fav",on:{"click":_vm.handleDownload}},[_c('div',[_vm._v(_vm._s(_vm.$t("cms_export")))]),_c('div',{staticClass:"download-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }